import _ from 'lodash';
import lspGridTemplate from './lsp-grid.html';
import lspTableTemplate from './components/lsp-table/lsp-table.html';
import lspMobileSortTemplate from './components/lsp-mobile-sort/lsp-mobile-sort.html';

const sorting = {
  asc: 'true',
  desc: 'false',
};

@Inject('$transclude')
class LspGridController {
  constructor() {
    this.isHeader = this.$transclude.isSlotFilled('header');
  }
}

/**
 LspTableController
 * */
@Inject('gettextCatalog')
class LspTableController {
  constructor() {
    this.sorting = {
      [this.defaultSortColumn]: this.defaultSortDirection || sorting.asc,
    };
    this.showHeader = this.showHeader || true;
    this.noDataText = this.noDataText || this.gettextCatalog.getString('Sorry, no results were found.');
    this.loadingText = this.gettextCatalog.getString('Loading...');
    this.headerGroups = _.flow([
      (headers) => headers.map((header) => (header ? _.set(header, 'e2eField', _.kebabCase(header.field)) : '')),
      (headers) => _.groupBy(headers, 'row')
    ])(this.headers || []);
  }

  switchSorting(header) {
    if (!_.get(header, 'sortable')) return null;

    const oldSorting = this.sorting[header.field];
    this.sorting = {
      [header.field]: oldSorting === sorting.asc ? sorting.desc : sorting.asc,
    };

    this.activeSort = {
      text: header.text,
      column: header.field,
      direction: this.sorting[header.field],
    };

    return this.onSortHandler({
      column: header.field,
      direction: this.sorting[header.field],
    });
  }
}

/**
 LspMobileSortController
 * */
class LspMobileSortController extends LspTableController {
  constructor(gettextCatalog) {
    super(gettextCatalog);
  }

  $onInit(){
    if (this.defaultSortColumn && this.defaultSortDirection) {
      this.sortBy = `${this.defaultSortColumn}-${this.defaultSortDirection}`;
    }

    this.fiteredHeaders = this.headers
      .filter((header) => (header ? header.sortable : false))
      .reduce(
        (prev, current) =>
          prev.concat([
            {
              value: `${current.field}-asc`,
              column: current.field,
              label: `${current.text} (ascending)`,
              ascending: true,
            },
            {
              value: `${current.field}-desc`,
              column: current.field,
              label: `${current.text} (descending)`,
              ascending: false,
            },
          ]),
        []
      );
  }
}

LspMobileSortController.$inject.gettextCatalog;

export class LspGridComponent {
  constructor() {
    this.transclude = {
      header: '?gridHeader',
      actions: '?gridActions',
      table: 'gridTable',
      footer: '?gridFooter',
    };
    this.template = lspGridTemplate;
    this.controller = LspGridController;
    return this;
  }
}

export class LspTableComponent {
  constructor() {
    this.bindings = {
      headers: '=',
      defaultSortDirection: '@',
      defaultSortColumn: '@',
      onSortHandler: '&',
      idPrefix: '@',
      hasData: '=',
      showHeader: '=?',
      noDataText: '=?',
      disableViewChange: '=?',
      title: '=?',
      loaded: '<',
    };
    this.transclude = {
      header1: '?header1',
    };
    this.template = lspTableTemplate;
    this.controller = LspTableController;
    return this;
  }
}

export class LspMobileSortComponent {
  constructor() {
    this.bindings = {
      headers: '=',
      onSortHandler: '&',
      defaultSortColumn: '@?',
      defaultSortDirection: '@?',
    };
    this.controller = LspMobileSortController;
    this.template = lspMobileSortTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-grid/lsp-grid-component.js